import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, catchError, map, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HotToastService } from '@ngxpert/hot-toast';
import * as Sentry from '@sentry/browser';

import { GlobalsService } from './globals.service';
import { environment } from '@environments/environment';

export interface DemandRequest {
  makeId: number;
  modelId: number;
  year?: number;
  colorId?: number;
  phoneCountryId: number;
  name: string;
  email: string;
  phone: string;
  message: string;
  customerIP: string;
  marketingAgree: boolean;
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class DemandService {
  private http = inject(HttpClient);
  private translateService = inject(TranslateService);
  private hotToastService = inject(HotToastService);
  private globalsService = inject(GlobalsService);

  sendForm(data: DemandRequest): Observable<any> {
    return this.http.post<any>(`${environment.apiNg}/v1/forms/car-demand/`, data, { headers: this.globalsService.headerHash() }).pipe(
      map((response: any) => {
        return response;
      }),
      this.hotToastService.observe({
        loading: this.translateService.instant('forms.hotToast.sendForm.loading'),
        success: this.translateService.instant('forms.hotToast.sendForm.success'),
        error: this.translateService.instant('forms.hotToast.sendForm.error'),
      }),
      catchError((e: any) => {
        const timestamp: number = new Date().getTime();
        Sentry.captureMessage('Nepodařilo se odeslat rezervační formulář - Timestamp: ' + timestamp + ' Error: ' + e.message, { level: 'fatal', extra: data as any });
        return of(e);
      }),
    );
  }

  getUserIp(): Observable<{ ip: string }> {
    return this.http.get<{ ip: string }>('https://api.ipify.org/?format=json');
  }
}
